import { PublicDocumentType, type PublicDocument } from './types';

const publicDocuments: Readonly<Record<PublicDocumentType, PublicDocument>> = {
  [PublicDocumentType.PRIVACY_POLICY]: {
    type: PublicDocumentType.PRIVACY_POLICY,
    version: 1,
  },
};

const getPublicDocument = (type: PublicDocumentType): PublicDocument => publicDocuments[type];

export { getPublicDocument };
